const t = "landing_z8Mh3", n = "landing__center_N2-uH", a = "mainArea_d-6d4", e = "rotationalArea_t7Lar", r = "buttonsArea_x0YXa", o = "buttonsArea__normal_btn_D3W4z", _ = "buttonsArea__primaryBtn_TgaOt", s = "buttonsArea__expand_7jxCI", i = "rotativeTitle_wShRx", A = "rotativeDesc_jjQsj", c = "footerArea_6U2b6", l = {
  landing: t,
  landing__center: n,
  mainArea: a,
  rotationalArea: e,
  buttonsArea: r,
  buttonsArea__normal_btn: o,
  buttonsArea__primaryBtn: _,
  buttonsArea__expand: s,
  rotativeTitle: i,
  rotativeDesc: A,
  footerArea: c
};
export {
  r as buttonsArea,
  s as buttonsArea__expand,
  o as buttonsArea__normal_btn,
  _ as buttonsArea__primaryBtn,
  l as default,
  c as footerArea,
  t as landing,
  n as landing__center,
  a as mainArea,
  e as rotationalArea,
  A as rotativeDesc,
  i as rotativeTitle
};
//# sourceMappingURL=shared-landing.module.scss.js.map
